module.exports = __webpack_public_path__ + "img/t1.26591d8a.svg";